import { coreTranslations } from '@sentinel/web-core';
import accounts from './accounts.json';
import auth from './auth.json';
import { chronicleEn as chronicle } from '@sentinel/shared';
import comms from './communications.json';
import connectivity from './connectivity.json';
import dashboard from './dashboard.json';
import drones from './drones.json';
import field from './field.json';
import inventory from './inventory.json';
import map from './map.json';
import markers from './markers.json';
import operations from './operations.json';
import personnel from './personnel.json';
import reports from './reports.json';
import platform from './platform.json';
import sensors from './sensors.json';
import settings from './settings.json';
import shell from './shell.json';
import teams from './teams.json';
import tracking from './tracking.json';
import weather from './weather.json';

const en = {
  ...coreTranslations.en,
  shell,
  auth,
  accounts,
  dashboard,
  chronicle,
  comms,
  operations,
  sensors,
  settings,
  platform,
  inventory,
  personnel,
  drones,
  field,
  map,
  markers,
  weather,
  teams,
  tracking,
  reports,
  connectivity,
};
export default en;
